// src/components/auth/ProtectedRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

function ProtectedRoute({ children }) {
  const { user, initialized, noAccess } = useAuth();

  if (!initialized) return null;

  if (!user) return <Navigate to="/login" replace />;
  if (noAccess) return <Navigate to="/login" replace state={{ noAccess: true }} />;

  return children;
}

export default ProtectedRoute;
